import template from './confirmDialog.html';
import controller from './confirmDialog.controller';
import './confirmDialog.scss';

let confirmDialogComponent = {
  bindings: {
    close: '&',
    dismiss: '&',
    resolve: '<'
  },
  template,
  controller,
  controllerAs: "vm"
};

export default confirmDialogComponent;



// WEBPACK FOOTER //
// ./client/app/common/confirmDialog/confirmDialog.component.js